

import moment from 'moment';

import { defineComponent } from 'vue';


export default defineComponent({
  name: "TimelineList",
  props: {
    title: {
      type: String,
      default: "",
    },
    rota: {
      type: Object,
      default: () => { {} },
    },
    description: {
      type: String,
      default: "",
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getRota(){
      if(!this.rota)return {};
      return this.rota
    }
  },
  methods: {
    toHora(date:any) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    },
    getDistance(rota: any) {
      if (!rota.Caminho) return "0,00";

      const total = rota.Caminho.reduce(
        (acc: number, item: any) => acc + item.distance, 
        0
      );

      return new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(total);
    }
  }
});
